
import {share} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable ,  Observer } from 'rxjs';

@Injectable()
export class PopoverService {

    // Events
    public onClosePopovers: Observable<string>;
    public onOpenPopover: Observable<string>;

    // Observers

    private _closePopoversObserver: Observer<string>;
    private _openPopoverObserver: Observer<string>;

    constructor() {
        this.onClosePopovers = new Observable<string>(
            (observer: any) => this._closePopoversObserver = observer
        ).pipe(share());
        this.onOpenPopover = new Observable<string>(
            (observer: any) => this._openPopoverObserver = observer
        ).pipe(share());
    }

    /**
     * emits an event to all popovers to close
     * @prop {string} id the id of the popover that is calling this function this will allow that popover to check if it made the call and ignoge
     */
    public closeOtherPopovers(id: string) {
        if (this._closePopoversObserver) {
            this._closePopoversObserver.next(id);
        }
    }

    public openPopover(id: string) {
        if (this._openPopoverObserver) {
            this._openPopoverObserver.next(id);
        }
    }
}
